import {
  Button,
  Dialog,
  DialogActions,
  DialogContent
} from '@material-ui/core';
import { useUnsafeTranslation } from '../../i18next';
import { DialogTitleWithTypography } from '../DialogTitleWithTypography';

export const DiscardChangesDialog = ({
  open,
  onCancel,
  onConfirm
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useUnsafeTranslation();
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitleWithTypography>
        {t('Discard changes')}?
      </DialogTitleWithTypography>
      <DialogContent>
        {t(`Your changes haven't been saved. Please choose how to proceed.`)}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onCancel}>
          {t('Back to editing')}
        </Button>
        <Button color="secondary" variant="contained" onClick={onConfirm}>
          {t('Discard changes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
